export default __webpack_public_path__ + "static/media/warning-icon-color.4137b673.svg";